import { type HttpResponseResolver, HttpResponse } from 'msw';
import { parse } from 'qs-esm';
import { type Compare, type YearsMode } from '#src/types';
import { buildMockData } from './__mocks__/build-data';

export const mockDataEndpoint: HttpResponseResolver<{ dataset: string }> = ({
  request,
}) => {
  const url = new URL(request.url);

  const parsedParams = parse(url.search, {
    ignoreQueryPrefix: true,
  });

  const props = {
    yearsMode: parsedParams.yearsMode as YearsMode,
    selectedYears: (parsedParams.selectedYears as string[]).map((y) =>
      Number(y)
    ),
    level: parsedParams.level as string,
    category: parsedParams.category as string,
    fundingSource: parsedParams.fundingSource as string,
    levelCompare: parsedParams.levelCompare as unknown as Compare,
    levelLimit: parsedParams.levelLimit
      ? parseInt(parsedParams.levelLimit as string, 10)
      : undefined,
    categoryCompare: parsedParams.categoryCompare as unknown as Compare,
    categoryLimit: parsedParams.categoryLimit
      ? parseInt(parsedParams.categoryLimit as string, 10)
      : undefined,
    fundingSourceCompare:
      parsedParams.fundingSourceCompare as unknown as Compare,
    fundingSourceLimit: parsedParams.fundingSourceLimit
      ? parseInt(parsedParams.fundingSourceLimit as string, 10)
      : undefined,
    isMonthly: ['CNT'].includes(parsedParams.dataset as string),
  };
  const data = buildMockData(props);

  return HttpResponse.json({
    params: props,
    data,
  });
};
